import { Label, List } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

const PayeurContactListItem = (props) => {
  const { telephone, website, mail } = props;

  const handleUrlClick = React.useCallback(() => {
    // le '//' permet de ne pas avoir à gérer le protocole http ou https
    window.open(`${_.startsWith(website, 'http') ? '' : '//'}${website}`, '_blank');
  }, [website]);

  return (
    <>
      <List.Description>
        <Label content={_.isEmpty(telephone) ? '-' : telephone} icon="phone" />
      </List.Description>
      <List.Description>
        <Label
          data-testid="contact-website-link"
          icon="globe"
          {...(_.isEmpty(website)
            ? {
                content: '-',
              }
            : {
                content: website,
                onClick: handleUrlClick,
              })}
        />
      </List.Description>
      <List.Description>
        <Label content={_.isEmpty(mail) ? '-' : mail} icon="mail" />
      </List.Description>
    </>
  );
};

export default PayeurContactListItem;
